<ion-row class="status-{{ dateDisplay?.state }}" [ngClass]="{ 'text-only': dateDisplay?.isTextOnly }">
  <ion-col size="12" class="label">
    <p id="AT_date_label" class="small">{{ dateDisplay?.label | translate: dateDisplay?.internationalizationType | uppercase }}</p>
  </ion-col>
  <ion-col size="12" class="date">
    <ion-icon [name]="dateDisplay?.icon"></ion-icon>
    <!-- Si es solo texto, mostrarlo tal cual -->
    <span id="AT_date_value" class="small" *ngIf="dateDisplay?.isTextOnly && dateDisplay?.date">{{ dateDisplay?.date }}</span>
    <!-- Si no es solo texto y hay fecha, formatearla -->
    <span id="AT_date_value" class="small" *ngIf="!dateDisplay?.isTextOnly && dateDisplay?.date">{{ dateDisplay?.date | date: (dateDisplay?.format ? dateDisplay?.format : 'dd/MM/yyyy HH:mm') }}</span>
    <!-- Si no hay fecha/texto, mostrar guión -->
    <span id="AT_date_value" class="small" *ngIf="!dateDisplay?.date">-</span>
  </ion-col>
</ion-row>
